import LoginTypes from "./LoginActionTypes";

//-------login POST---------------------
export const postLoginRequest = (payload) => ({
  type: LoginTypes.POST_LOGIN_REQUEST,
  payload: payload,
});

export const postLoginResponse = (payload) => ({
  type: LoginTypes.POST_LOGIN_RESPONSE,
  payload: payload,
});

export const postLoginResponseClear = () => ({
  type: LoginTypes.POST_LOGIN_RESPONSE_CLEAR,
});

export const getAMCRequest = (payload) => ({
  type: LoginTypes.GET_AMC_REMINDERS_REQUEST,
  payload,
});

export const getAMCResponse = (payload) => ({
  type: LoginTypes.GET_AMC_REMINDERS_RESPONSE,
  payload,
});

export const getAMCResponseClear = () => ({
  type: LoginTypes.GET_AMC_REMINDERS_RESPONSE_CLEAR,
});
